/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import styles from './FloDateRangePicker.module.css';
import classnames from 'classnames';
import { DateRangePicker, FocusedInputShape } from 'react-dates';
import { FloButtonType, FloComponentProps, FloButton } from 'components';
import 'react-dates/lib/css/_datepicker.css';
import moment, { Moment } from 'moment';
import { getDateRange, IntervalType } from 'model';
import { useTranslation } from 'react-i18next';

const START_DATE: FocusedInputShape  = 'startDate';
const END_DATE: FocusedInputShape    = 'endDate';
const dateFormat = 'YYYY-MM-DD';

const defaultPresets = [
  { id: 'today', interval: IntervalType.HOURS },
  { id: 'days', interval: IntervalType.DAYS },
  { id: 'weeks', interval: IntervalType.WEEKS },
  { id: 'months', interval: IntervalType.MONTHS }
];

type CalendarPresetsProps = {
  onChange:   (startDate?: string, endDate?: string) => void;
}

const CalendarPresets : React.FC<CalendarPresetsProps> = React.memo(({
  onChange,
}) => {
  const { t } = useTranslation();
  return <div className={styles.presetContainer}>
    {
      defaultPresets.map(item => (
        <FloButton
          key       = {item.id}
          className = {styles.presetButton}
          text      = {t(item.id)}
          onClick   = {() => {
            const range = getDateRange(item.interval);
            onChange(range.from, range.to);
          }}
          type      = {FloButtonType.SECONDARY}
        />
      ))
    }
  </div>
});

interface FloDateRangePickerProps extends FloComponentProps {
  startDate?: string;
  endDate?:   string;
  onChange:   (startDate?: string, endDate?: string) => void;
}

export const FloDateRangePicker: React.FC<FloDateRangePickerProps> = React.memo(({
  className,
   startDate,
  endDate,
  onChange,
}) => {
  const [ focusedInput, setFocusedInput ] = useState<FocusedInputShape | null>(null);

  return (
    <div
      className={classnames(styles.root, className)}
    >
      <DateRangePicker
        startDateId         = {START_DATE}
        endDateId           = {END_DATE}
        renderCalendarInfo  = {() => <CalendarPresets onChange={onChange} />}
        onDatesChange       = {({ startDate: start, endDate: end }) => {
          onChange(start?.format(dateFormat), end?.format(dateFormat));
        }}
        onFocusChange       = {(input) => setFocusedInput(input)}
        focusedInput        = {focusedInput}
        startDate           = {startDate ? moment(startDate) : null}
        endDate             = {endDate ? moment(endDate) : null}
        isOutsideRange      = {(date) => date.clone().subtract(1, 'day').isAfter(moment())}
        minDate             = {moment().subtract(1, 'year') as Moment}
        initialVisibleMonth = {() => startDate ? moment(startDate) : moment().subtract(1, 'month')}
      />
    </div>
  );
});
